export function formatMsisdn(value) {
    if (value) {
        let msisdnWithoutChars = (((value.replace(/_/g,''))
            .replace(/ /g,''))
            .replace(/\(/,''))
            .replace(/\)/,'');

        return msisdnWithoutChars;
    }
}